// extracted by mini-css-extract-plugin
export default {"feature-container":"Feature_feature-container__ZTiDM","heading-container":"Feature_heading-container__EclJJ","feature-description":"Feature_feature-description__UphG+"};